import React from "react";
import injectSheet from "react-jss";
import classNames from "classnames";
import Icon from "../../assets/icons/Icon";

const LogoffNavItem = ({ visible, classes, className, onClickButton }) => {
  return (
    <>
      <button
        id="logout"
        className={classNames(
          className,
          classes.button,
          visible && classes.active
        )}
        onClick={onClickButton}
      >
        <div id="logout" style={{ display: "flex", alignItems: "center" }}>
          <div>
            <div id="logout" className={classes.iconStyle}>
              <Icon type="logoff" fill="white" width="20px" />
            </div>
            <div id="logout">Logga ut</div>
          </div>
        </div>
      </button>
    </>
  );
};

const styles = (theme) => ({
  iconStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "4px",
    marginTop: "3px",
  },
  button: {
    border: "0",
    display: "flex",
    height: "100%",
    padding: "0",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    textAlign: "center",
    cursor: "pointer",
    color: "white",
    font: "500 11px Roboto",
    lineHeight: "unset",
    outline: "none",
    width: "64px",
    "& svg g polygon": {
      fill: `${theme.themeHoverTextDarkColor}!important`,
    },
    "& svg path, circle, rect": {
      fill: `${theme.themeHoverTextDarkColor}!important`,
    },
    "&:hover": {
      backgroundColor: theme.themeHoverDark,
      color: theme.themeHoverTextDarkColor,
    },
  },
});

export default injectSheet(styles)(LogoffNavItem);
